/* monitoring: the dashboard, the monitoring page and one match under review —
 * translated in the Wave 3 pass (2026-09-30). Mirrors en/monitoring.ts. */
export default {
  dash: {
    subtitle: 'Was die Überwachung in Ihrem Portfolio gefunden hat.',
    updated: 'letzte Prüfung {when}',
    addTrademark: 'Marke hinzufügen',
    kpi: {
      label: 'Überblick',
      watched: 'Überwachte Marken',
      watchedOf: 'von {total}',
      unwatched: '{n} ohne jede Überwachung',
      matches: 'Gefundene Treffer',
      highRisk: 'Treffer mit hohem Risiko',
      closeWithin: 'endet binnen 14 Tagen | enden binnen 14 Tagen',
      nextWindow: 'Nächste Frist: {when}',
    },
    recent: {
      title: 'Neueste Überwachungstreffer',
      viewAll: 'Alle {n} anzeigen',
      col: {
        detected: 'Gefunden',
        protected: 'Geschützt',
        risk: 'Risiko',
        registry: 'Register',
        classes: 'Klassen',
        deadline: 'Frist',
        status: 'Stand',
      },
    },
    deadlines: {
      title: 'Anstehende Fristen',
      badge: '{n} mit hohem Risiko binnen 14 Tagen',
      open: 'Diesen Treffer öffnen',
      viewAll: 'Alle Treffer nach Frist',
    },
    registryLastScan: '· letzte Prüfung {when}',
  },

  mon: {
    subtitle: {
      matched:
        'veröffentlichte Marke mit Treffer gegen Ihr Portfolio | veröffentlichte Marken mit Treffern gegen Ihr Portfolio',
      across: 'Bei',
      ofYours: 'Ihrer Marken',
      registries: '{n} Register',
    },
    lastScan: 'Letzte Prüfung: {when}',
    yours: 'Ihre Marke',
    trademarks: '{n} Marke | {n} Marken',
    filters: 'Filter',
    addToMonitoring: 'Zur Überwachung hinzufügen',
    kpi: {
      label: 'Trefferübersicht',
      total: 'Treffer insgesamt',
      judged: '{n} vom KI-Prüfer gelesen',
      highHint: 'Prüfung nötig · {n} enden binnen 14 Tagen',
      medHint: 'Prüfung empfohlen',
      lowHint: 'Lesen, wenn Zeit ist',
    },
    filter: {
      window: 'Können Sie noch handeln?',
      windowOpen: 'Frist läuft noch',
      windowUnknown: 'Keine Frist veröffentlicht',
      windowClosed: 'Frist abgelaufen',
      windowAll: 'Alle anzeigen',
      risk: 'Risiko',
      registry: 'Register',
      state: 'Bearbeitungsstand',
    },
    state: {
      new: 'Wartet auf Prüfung',
      reviewed: 'Geprüft',
      dismissed: 'Verworfen',
      escalated: 'Zum Widerspruch vorgemerkt',
    },
    toolbar: {
      shown: '{n} angezeigt',
      grouped: 'Nach Ihrer Marke gruppiert',
      sortLabel: 'Sortierung',
      sort: 'Nächste Frist zuerst',
    },
    intro: {
      bands:
        'Jedes schattierte Band unten ist eine Ihrer eigenen Marken. Die Zeilen darunter sind Marken aus den Markenblättern der Register, die bei der Prüfung als mögliche Kollision mit ihr gefunden wurden.',
      openOnly:
        'Angezeigt werden nur Treffer, deren Widerspruchsfrist noch nicht abgelaufen ist — {link}, darunter {n} mit abgelaufener Frist.',
      showAll: 'alle {n} anzeigen',
    },
    thead: {
      detected: 'Gefundene Marke',
      similarity: 'Ähnlichkeitsanalyse',
      riskDeadline: 'Risiko & Frist',
      actions: 'Aktionen',
    },
    band: {
      toggle: 'Treffer für {name} ein- oder ausblenden',
      countWord: 'Treffer',
      reg: 'Reg.-Nr. {n}',
      active: 'Überwachung aktiv',
      paused: 'Überwachung pausiert',
      notScanned: 'Noch nicht geprüft',
    },
    logo: 'Logo von {name}',
    empty: 'Keine Treffer in dieser Ansicht.',
    clearFilters: 'Filter zurücksetzen',
    clearHint: '{link}, um alle zu sehen.',
    showing: '{shown} von {total} Treffern angezeigt, nächste Fristen zuerst.',
    row: {
      view: 'Details ansehen',
      dismiss: 'Treffer verwerfen',
    },
    dismissPrompt:
      'Warum ist „{name}“ keine Kollision?\n\nIhre Begründung wird mit dem Treffer gespeichert. Kein Modell wird damit neu trainiert — sie zeigt uns, ob die KI richtig lag, und an ihr werden die Schwellen später ausgerichtet.',
    rail: {
      label: 'Zusammenfassung',
      found: 'Was die Prüfung gefunden hat',
      summary:
        'Die Prüfung hat {matches} gegen Ihr Portfolio gefunden, davon {high} mit hohem Risiko.',
      matches: '{n} Treffer',
      breakdown: 'Aufteilung nach Risiko',
      total: 'Alle Treffer',
      decided: 'Wie entschieden wurde',
      judged: 'Vom KI-Prüfer gelesen',
      judgedSub: 'Ein Urteil mit Begründung',
      rule: 'Per Regel gefunden',
      ruleSub: 'Identisch oder nahezu identisch',
      awaiting: 'Wartet auf Ihre Prüfung',
      awaitingSub: 'Noch nicht bearbeitet',
    },
    health: {
      title: 'Zustand der Überwachung',
      summary: '{count} Marken werden überwacht. Letzte Prüfung: {when}.',
      count: '{n} von {total}',
      unwatched: 'Gar nicht überwacht',
      unwatchedSub: 'Für diese wird kein Register geprüft',
      registries: 'Überwachte Register',
      workload: 'Arbeitsstand',
      awaiting: 'Warten auf Entscheidung',
      awaitingSub: 'Noch niemand hat darauf geantwortet',
      next: 'Nächste ablaufende Frist',
      nextSub: 'Unter den noch unbeantworteten Treffern',
    },
    start: {
      title: 'Wo anfangen',
      review: 'Prüfen Sie zuerst {high}.',
      high: 'den {n} Treffer mit hohem Risiko | die {n} Treffer mit hohem Risiko',
      closingCount: '{n} davon',
      closingTail:
        'hat eine Widerspruchsfrist, die binnen 14 Tagen endet. | haben eine Widerspruchsfrist, die binnen 14 Tagen endet.',
      button: 'Treffer mit hohem Risiko prüfen',
    },

    deadline: {
      today: 'Endet heute',
      closedDays: 'Seit {n} Tag abgelaufen | Seit {n} Tagen abgelaufen',
      closedMonths: 'Seit {n} Monat abgelaufen | Seit {n} Monaten abgelaufen',
      closedYears: 'Seit {n} Jahr abgelaufen | Seit {n} Jahren abgelaufen',
      on: 'Frist: {date}',
    },
    since: {
      never: 'nie',
      now: 'gerade eben',
      minutes: 'vor {n} Min.',
      hours: 'vor {n} Std.',
      days: 'vor {n} Tag | vor {n} Tagen',
    },
    tag: {
      filed: 'Angemeldet am {date}',
      judge: 'KI · {model}',
      judgeUnnamed: 'KI-Prüfer',
      rule: 'Regeltreffer',
    },
    channel: {
      visual: 'Bildlich',
      aural: 'Klang',
      phonetic: 'Klang',
      conceptual: 'Bedeutung',
      name_semantic: 'Bedeutung',
      goods: 'Waren/DL',
      name_trigram: 'Schreibweise',
      name_contains: 'Enthalten',
      name_stem: 'Gemeinsamer Stamm',
      name_edit: 'Ähnliche Schreibweise',
      logo_text: 'Wörter im Logo',
      logo_visual: 'Optik',
      logo_phash: 'Gleiches Bild',
      gate: 'Schwelle',
      rerank: 'Nachsortierung',
    },
    belt: {
      edit: '{a} und {b} unterscheiden sich in {n} Buchstaben von {letters}',
      stemStart: 'Beide beginnen mit {stem}',
      stemInside: 'Beide enthalten den Stamm {stem}',
      stemCoverage: '{text}, das sind {pct} % des Wortes',
      contains: '{inner} ist in {outer} enthalten',
      sound: 'Beide Namen teilen einen Klangschlüssel ({keys})',
      spelling: 'Die Schreibweisen überschneiden sich (Ähnlichkeit {n})',
      meaning: 'Die Namen sind bedeutungsverwandt (Ähnlichkeit {n})',
      goods: 'Die Waren und Dienstleistungen liegen nahe beieinander (Ähnlichkeit {n})',
      logoWords: 'In beiden Logos stehen dieselben Wörter: {words}',
      samePicture: 'Die Bilder sind nahezu identisch ({n} Bit Abstand)',
      looksAlike: 'Die Bilder sehen sich ähnlich (Ähnlichkeit {n})',
      rerank: 'Bewertung der Nachsortierung: {score} ({band})',
      rerankBand: 'Nachsortierung: {band}',
    },
    rerankBand: {
      floor: 'unter der Linie',
      gray: 'Grauzone',
      top: 'Spitzengruppe',
      unscored: 'nicht bewertet',
    },
    decision: {
      ceiling: 'Sofort vorgelegt',
      surface: 'Vorgelegt',
      gray: 'Grauzone',
      floor: 'Unter der Schwelle',
      dismiss: 'Verworfen',
    },
    gate: {
      identical: 'identischer Name',
      edits: 'Name bis auf {n} Buchstaben gleich',
      sound: 'gleicher Klang bei gleicher Länge',
      picture: 'gleiches Bild ({n} Bit Abstand)',
      floor: 'alle Signale unter {line}',
    },
    escalation: {
      notDismissed: 'Nicht weitergegeben: Das erste Modell hat das Paar nicht verworfen',
      below: 'Nicht weitergegeben: Nachsortierung {score}, unter {line}',
      noSecond:
        'Nicht weitergegeben: Nachsortierung {score} ≥ {line}, aber kein zweites Modell verfügbar',
      escalated:
        'An ein zweites Modell weitergegeben: Das erste hat das Paar verworfen, Nachsortierung {score} ≥ {line}',
    },
    markType: {
      word: 'Wortmarke',
      figurative: 'Bildmarke',
      combined: 'Wort-/Bildmarke',
      sound: 'Hörmarke',
      other: 'Sonstige',
    },
    brandStatus: {
      registered: 'Eingetragen',
      pending: 'Anhängig',
      filed: 'Angemeldet',
      published: 'Veröffentlicht',
      opposed: 'Im Widerspruch',
      cancellation_procedure: 'Im Löschungsverfahren',
      expired: 'Abgelaufen',
      refused: 'Zurückgewiesen',
      withdrawn: 'Zurückgenommen',
    },
    feedback: {
      confirm: 'Als Kollision bestätigt',
      escalate: 'Zum Widerspruch vorgemerkt',
      dismiss: 'Verworfen',
      false_positive: 'Keine Kollision',
    },
  },

  match: {
    review: 'Trefferprüfung',
    title: '{found} gegen {ours}',
    subtitle: 'Ihre Marke {ours} gegen die {registry}-Veröffentlichung {found}',
    previous: 'Vorheriger',
    next: 'Nächster',
    close: 'Schließen',
    back: 'Zurück zur Überwachung',
    yourMark: 'Ihre überwachte Marke',
    position: 'Treffer {p} von {total}',
    viewTrademark: 'Zur Marke →',
    compare: 'Markenvergleich',
    found: 'Im Markenblatt gefunden',
    vs: 'gegen',
    field: {
      classes: 'Nizza-Klassen',
      registered: 'Eingetragen',
      applicationNo: 'Anmeldenummer',
      type: 'Markenform',
      filed: 'Angemeldet',
      registry: 'Register',
      name: 'Markenname',
      owner: 'Inhaber',
      registrationNo: 'Registernummer',
      status: 'Rechtsstand',
      deadline: 'Widerspruchsfrist',
      vienna: 'Wiener Klassifikation',
      designated: 'Benannte Länder',
      found: 'Gefunden',
      reviewState: 'Bearbeitungsstand',
    },
    nonePublished: 'Keine veröffentlicht',
    score: {
      judge: 'KI-Risikowert',
      rules: 'Regelwert',
      low: 'Gering',
      med: 'Mittel',
      high: 'Hoch',
      window: 'Widerspruchsfrist',
      decidedBy: 'Entschieden von',
      matchingRules: 'Abgleichsregeln',
    },
    tab: {
      label: 'Abschnitte der Trefferprüfung',
      analysis: 'Warum gefunden',
      details: 'Beide Marken',
      timeline: 'Zeitverlauf',
    },
    analysis: {
      judge: 'Was die KI gelesen hat',
      rules: 'Was die Regeln gefunden haben',
      judgeIntro:
        'Ein Modell hat dieses Paar gelesen wie ein Prüfer und die vier Werte unten vergeben. Das ist eine Einschätzung, keine Entscheidung: Sie dient dazu, Ihnen die Paare vorzulegen, die Ihre Zeit wert sind.',
      rulesIntro:
        'Kein Modell hat dieses Paar gelesen. Es steht hier, weil die Abgleichsregeln unten angeschlagen haben — jede davon können Sie selbst nachprüfen.',
      firstReading: 'Erste Lesung — {model}: {verdict}',
      surfaced: 'Sofort vorgelegt:',
      shared: 'Gemeinsame Nizza-Klassen: {list}',
    },
    decide: {
      title: 'Ihre Entscheidung',
      intro:
        'Was immer Sie entscheiden, wird mit dem Treffer gespeichert: Daran messen wir, ob die KI richtig lag, und daran werden die Schwellen später ausgerichtet. Zustimmen kostet einen Klick. Widersprechen verlangt eine Begründung, denn diese Antwort sagt uns etwas, das wir noch nicht wussten.',
      already: 'Bereits beantwortet:',
      someone: 'Jemand',
      disagreed: '· anderer Meinung als die Maschine',
      saving: 'Wird gespeichert…',
      confirm: 'Ja, das ist eine Kollision',
      escalate: 'Kollision — für Widerspruch vormerken',
      orDismiss: 'Oder sagen Sie, dass es keine Kollision ist, und warum:',
      reasons: 'Grund für das Verwerfen',
      own: 'In Ihren eigenen Worten',
      required: '(Pflichtfeld)',
      optional: '(freiwillig)',
      placeholder:
        'z. B. Sie verkaufen Industriesoftware für Öl und Gas — keine Überschneidung mit unserem Verbraucherprodukt, trotz derselben Nizza-Klasse auf dem Papier.',
      hint: 'Wird mit Ihrer Entscheidung gespeichert. Freitext steht neben dem Grund oben, nicht an seiner Stelle, denn eine Liste lässt sich zählen, Prosa nicht.',
      failed: 'Ihre Antwort wurde nicht gespeichert. Versuchen Sie es gleich noch einmal.',
      dismiss: 'Keine Kollision — verwerfen',
    },
    reason: {
      different_market: {
        label: 'Andere Branche oder anderer Markt',
        sub: 'Die tatsächliche Benutzung überschneidet sich nicht',
      },
      weak_sound: {
        label: 'Schwache klangliche Nähe',
        sub: 'Die Schreibweise wurde stärker gewichtet als der Klang',
      },
      not_confusable: {
        label: 'Keine Verwechslungsgefahr',
        sub: 'In der Praxis rechtlich unerheblich',
      },
      coexists: {
        label: 'Besteht bereits nebeneinander',
        sub: 'Abgrenzungsvereinbarung liegt vor',
      },
      visual_difference: {
        label: 'Der visuelle Unterschied überwiegt',
        sub: 'Logos oder Aufmachung klar verschieden',
      },
      other: {
        label: 'Sonstiges',
        sub: 'Begründen Sie in eigenen Worten',
      },
    },
    details: {
      title: 'Die im Markenblatt gefundene Marke',
      goods: 'Waren und Dienstleistungen in Ihren gemeinsamen Klassen',
    },
    timeline: {
      title: 'Was wann geschah',
      registered: '{name} eingetragen',
      filed: '{name} angemeldet',
      found: 'Bei der Prüfung gefunden',
      read: 'Gelesen von {model}',
      closes: 'Widerspruchsfrist endet',
    },
    rail: {
      label: 'Zusammenfassung des Treffers',
      this: 'Dieser Treffer',
      applicant: 'Dieser Anmelder, anderswo',
      applicantSummary: '{owner} hat {filings} gegen Ihr Portfolio.',
      sameApplicant: 'Derselbe Anmelder',
      otherFilings: '{n} weitere Anmeldung mit Treffer | {n} weitere Anmeldungen mit Treffern',
      against: 'gegen {brand}',
      filing: 'Diese Anmeldung, gegen Ihre anderen Marken',
      filingSummary: 'Dieselbe Anmeldung traf auch {marks}.',
      otherMarks: '{n} weitere Ihrer Marken',
      othersAgainst: 'Weitere gegen {brand}',
      othersSummary:
        'Gegen diese Marke wurde {n} weitere Anmeldung gefunden. | Gegen diese Marke wurden {n} weitere Anmeldungen gefunden.',
      rest: 'Den Rest prüfen',
      nextForBrand: 'Nächster Treffer für diese Marke',
      backAll: 'Zurück zu allen Treffern',
    },
  },
} as const
